// import { Save } from '@mui/icons-material';
//import { Label } from '@mui/icons-material';
import { FormHelperText, MenuItem, Select } from '@mui/material';
import { FormControl} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { ThemeProvider } from '@mui/material/styles';
import { NestedMenuItem } from 'mui-nested-menu';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { categories } from '../data/Interfaces';
import useUtilities from '../hooks/useUtilities';
import useWindowSize from '../hooks/useWindowSize';
import { FieldComponentFont } from '../Styles/componentStyles';
import { CompareTwoString } from '../Utils/utils';

function CategoriesSubCategoriesDropDown({setCategorie,label,typeTraitement,width,check,setSousCategorie,sousCategorie, name}) {

    CategoriesSubCategoriesDropDown.propTypes = {
        setSousCategorie:PropTypes.func,
        sousCategorie:PropTypes.any,
        name:PropTypes.any,
        setCategorie: PropTypes.func,
        width: PropTypes.any,
        label:PropTypes.any,
        typeTraitement:PropTypes.any,
        check:PropTypes.func,
    };

    const { errors, showErrors } =useUtilities();
    const error = name in errors ? errors[name] : undefined;

    const {inputSize} = useWindowSize();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        return setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    //const menuItemsData = {
    //    label: 'Categories',
    //    items: categories.map((category) => {
    //        /*value: 'Digital',
    //        label: 'Digital',
    //        sousCategories: [*/
    //        return {
    //            label: category.label,
    //            // leftIcon: <Save />,
    //            callback: () => console.log({ valueCategory: category.value }),
    //            items: category.sousCategories.map((sousCategory) => {
    //                return {
    //                    label: sousCategory,
    //                    // rightIcon: <Save />,
    //                    callback: () => {
    //                        console.log({ sousCategory, valueCategory: category.value });
    //                        //setSousCategorie(sousCategory);
    //                        if (setCategorie) setCategorie(category.value);
    //                    },
    //                };
    //            }),
    //        };
    //    }),
    //};

    useEffect(() => {
        console.log('width',width);
        if(sousCategorie)
            setCategorie(sousCategorie);
    }, []);

    return (
    //<NestedDropdown
    //    sx={{ width:  '538.50px'}}
    //    menuItemsData={menuItemsData}
    //    MenuProps={{elevation: 3}}
    //    ButtonProps={{
    //        variant: 'outlined',
    //        root: {
    //            '&$disabled $notchedOutline': {
    //                borderColor: 'orange'
    //            }
    //        },
    //    }}

    //    onClick={() => console.log('Clicked')}
    ///>
        <>
            <ThemeProvider theme={FieldComponentFont}>
                <FormControl
                    fullWidth
                    style={{width: width||'220px'}}
                    error={!!error && showErrors}
                >
                    <InputLabel
                        //shrink={true}
                        id="demo-simple-select-label"
                        sx={{
                            textAlign: 'center',
                            top:'-4px',
                            //transform: (!open && inputSize === 'small') ? 'translateY(6%)' : 'none',
                            //paddingLeft: inputSize === 'small' ? '12px' : '0px',
                        }}
                    >{label}</InputLabel>
                    <Select
                        label={label}
                        value={sousCategorie}
                        name={name}
                        size={inputSize}
                        open={open}
                        //defaultValue=''
                        //notched={true}
                        //placeholder='Catégories'
                        onOpen={handleClick}
                        onClose={handleClose}
                        disabled={typeTraitement == 'readOnly' ? true : false}
                        //sx={{
                        //    '& > :not(style)': {borderRadius: '8px',background: 'white' },
                        //}}
                        style={{borderRadius: '8px',background: 'white'}}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                    >
                        {/*{categories.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        ))}*/}
                        {categories.map((element) => (
                            element.sousCategories.map((option) => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    //style={{width: '100%'}}
                                    sx={{
                                        display: 'none',
                                        //width: width||'210px'
                                        width:'100%',
                                    }}
                                >
                                    {option.label}
                                </MenuItem>
                            ))
                        ))}
                        {categories.map((element) => (
                            <NestedMenuItem
                                label={element.label}
                                parentMenuOpen={open}
                                //style={{width: '100%'}}
                                //sx={{width:width||'210px'}}
                                //sx={{ width:'100%'}}
                                //ButtonProps={{
                                //    //root: {
                                //    //    '&$disabled $notchedOutline': {
                                //    //        borderColor: 'orange'
                                //    //    }
                                //    //},
                                //    root: {
                                //        '&.MuiMenu-paper': {
                                //            '&.MuiPopover-paper': {
                                //                left: '-50px',
                                //                zIndex:'1000',
                                //            },
                                //        },
                                //    },
                                //}}
                                key={element.value}
                                menuPosition="bottom"
                                //style={{
                                //    position: 'absolute',
                                //    //display: open ? 'block' : 'none', // Display the second list when the first list is clicked
                                //    zIndex: 1, // Ensure it appears above the first list
                                //}}
                            >
                                {
                                    element.sousCategories.map((option) => (
                                        <MenuItem
                                            data-value={option.value}
                                            key={option.value}
                                            sx={{width:'340px'}}
                                            //style={{width: '100%'}}
                                            //sx={{ width:'100%'}}
                                            onClick={(e) => {
                                                //console.log('SousCategorie',e.target.dataset.value);
                                                //console.log('Categorie',element.label);
                                                //setCategorie(e.target.dataset.value);
                                                if(check)
                                                    if(!CompareTwoString(sousCategorie,e.target.dataset.value))
                                                        check(false);
                                                setSousCategorie(e.target.dataset.value);
                                                setCategorie(element.label);
                                                handleClose();
                                            }}
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))
                                }
                            </NestedMenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{showErrors && (error?? '')}</FormHelperText>
                </FormControl>
            </ThemeProvider>
        </>
    );
}

export default CategoriesSubCategoriesDropDown;
{/*
    //* I had to add the nested dropDown like guru :
    and I choosed this : https://www.npmjs.com/package/mui-nested-menu
    over this: https://www.npmjs.com/package/material-ui-nested-menu-item
    because it's newer with more collaborator: maybe It has a better future :)
    even the other one has more downloads
*/}
// ? OLD Categories ANd SubCategories using two dropDown
// import { categories } from '../../../data/Interfaces';
// const [categorie, setCategorie] = useState('SAP');
// const [sousCategorie, setSousCategorie] = useState('');
// const [sousCategoriesArray, setSousCategoriesArray] = useState([]);
// useEffect(() => {
//     // get les sous-categories of this categorie
//     setSousCategoriesArray(categories.find((cat)=> cat.value === categorie).sousCategories);
//     // console.log(categories.find((cat)=> cat.value === categorie).sousCategories);
//     // setSousCategorie('');
// }, [categorie]);
// useEffect(() => {
//     // get les sous-categories of this categorie
//     console.log(sousCategoriesArray, sousCategorie);
// }, [sousCategoriesArray]);
{
    /* <div className='Frame10129 WidthApp'>
                                        <p className='IntitulePoste'> Catégories</p>
                                        <Form.Select
                                            aria-label="categorie"
                                            value={categorie}
                                            onChange={(e) => setCategorie(e.target.value)}
                                        >
                                            {categories.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>

                                    <div className='Frame10129 WidthApp'>
                                        <p className='IntitulePoste'> Sous catégorie</p>
                                        <Form.Select
                                            aria-label="categorie"
                                            value={sousCategorie}
                                            onChange={(e) => setSousCategorie(e.target.value)}
                                        >
                                            {sousCategoriesArray.map((sousCateg,index) => (
                                                <option
                                                    key={index}
                                                    value={sousCateg}
                                                >
                                                    {sousCateg}
                                                </option>
                                            ))
                                            }
                                        </Form.Select>
                                    </div> */
}

{/* // * with double inputs */}
{/* <div className='Frame10129 WidthApp'>
                                <p className='IntitulePoste'> Catégories</p>
                                <Form.Select
                                    aria-label="categorie"
                                    value={categorie}
                                    onChange={(e) => setCategorie(e.target.value)}
                                >
                                    {categories.map((option) => (
                                        <option
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>

                            <div className='Frame10129 WidthApp'>
                                <p className='IntitulePoste'> Sous catégorie</p>
                                <Form.Select
                                    aria-label="categorie"
                                    value={sousCategorie}
                                    onChange={(e) => setSousCategorie(e.target.value)}
                                >
                                    {sousCategoriesArray.map((sousCateg,index) => (
                                        <option
                                            key={index}
                                            value={sousCateg}
                                        >
                                            {sousCateg}
                                        </option>
                                    ))
                                    }
                                </Form.Select>
                            </div> */}